import React from "react";
import "../styles/donation-prompt.css";

const DonationPrompt = ({
  show,
  donationUrl,
  onClose,
  onContinue,
  isArabic = false,
}) => {
  if (!show) {
    return null;
  }

  const copy = isArabic
    ? {
        title: "يرجى التفكير في التبرع",
        body: "يساعد دعمكم في الحفاظ على هذا الأرشيف الرقمي وإتاحته للجميع.",
        donate: "تبرع الآن",
        continue: "متابعة التصفح",
        close: "إغلاق",
      }
    : {
        title: "Please consider donating",
        body: "Your support helps keep this digital archive available and accessible.",
        donate: "Donate",
        continue: "Continue browsing",
        close: "Close",
      };

  return (
    <div className="donation-prompt-backdrop" role="presentation">
      <div
        aria-modal="true"
        className="donation-prompt"
        dir={isArabic ? "rtl" : "ltr"}
        role="dialog"
      >
        <button
          aria-label={copy.close}
          className="donation-prompt__close"
          onClick={onClose}
          type="button"
        >
          &times;
        </button>
        <h2 className="donation-prompt__title">{copy.title}</h2>
        <p className="donation-prompt__body">{copy.body}</p>
        <div className="donation-prompt__actions">
          <a className="donation-prompt__donate" href={donationUrl}>
            {copy.donate}
          </a>
          <button
            className="donation-prompt__continue"
            onClick={onContinue}
            type="button"
          >
            {copy.continue}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DonationPrompt;
